import { IApplicationState } from '../../types/store';

export function selectDetectedLocation(state: IApplicationState) {
  return state.geo.detectedLocation;
}
